var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column q-form",class:{ 'q-form-row flex-xl-row': _vm.row, 'q-form-col': !_vm.row }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }